import searchIcon from './search.svg';
import appLogo from './logo.svg';

export const imageMappings = {
    searchIcon,
    appLogo
}